import React from 'react';
import { Box } from '@mui/material';
import Content from '../components/Content';
import SignUpCard from '../components/SignUpCard';

export default function SignUpPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 4,
        p: 2,
      }}
    >
      {/* Left Side: Content (hidden on extra-small screens) */}
      <Box
        sx={{
          flex: 1,
          display: { xs: 'none', md: 'flex' },
          justifyContent: 'center',
        }}
      >
        <Content />
      </Box>

      {/* Right Side: SignUpCard */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <SignUpCard />
      </Box>
    </Box>
  );
}
